<!--
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-29 14:06:14
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-29 14:32:25
-->
<template>
    <div id="app">
        <keep-alive>
            <router-view :key="key" v-if="keepAlive" />
        </keep-alive>
        <router-view :key="key" v-if="!keepAlive" />
        <!-- 温馨提示：协议更新 -->
        <agreement v-if="this.canShowAreement" v-model="show" />
        <!-- 登录 -->
        <van-dialog
            :message="loginCard.text"
            :value="loginCard.type"
            title="提醒"
            :confirm-button-text="loginCard.button || '去登录'"
            confirm-button-color="#00BCD1"
            @confirm="confirm"
        />
        <!-- 新手引导 -->
        <newbie-guide></newbie-guide>
    </div>
</template>

<script>
import agreement from "./views/dialog/agreement";
import { mapGetters } from "vuex";
import { removeToken } from "./utils/auth";

export default {
    name: "App",
    components: { agreement },
    computed: {
        ...mapGetters(["loginCard", "showAgreement"]),
        show: {
            get() {
                return this.showAgreement;
            },
            set(val) {
                this.$store.commit("user/showAgreement", val);
            }
        },
        keepAlive() {
            return this.$route.meta && this.$route.meta.keepAlive;
        },
        canShowAreement() {
            return this.$route.name != "agreementDetail";
        },
        key() {
            return this.$route.fullPath;
        }
    },
    mounted() {
        this.initListener();
    },
    methods: {
        confirm() {
            /**
             * 保存当前页面并跳转
             */
            if (this.loginCard.code === "-2") {
                this.$router.replace({
                    path: "/change/login",
                    query: {
                        phone: this.loginCard.phone
                    }
                });
            } else {
                this.$router.replace({
                    path: "/login",
                    query: {
                        type: this.loginCard.code === "-1" ? "bind" : "reg"
                    }
                });
            }
            if (this.loginCard.code == 1001 || this.loginCard.code == 1002) {
                removeToken();
            }
            this.$store.dispatch("user/changeLoginCard", {
                type: false,
                text: this.loginCard.text
            });
        },
        initListener() {
            // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
            this.tim.on(
                this.TIM.EVENT.SDK_READY,
                this.onReadyStateUpdate,
                this
            );
            // // SDK NOT READT
            this.tim.on(
                this.TIM.EVENT.SDK_NOT_READY,
                this.onReadyStateUpdate,
                this
            );
            // // SDK内部出错
            // this.tim.on(this.TIM.EVENT.ERROR, this.onError)
            // // 收到新消息
            this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
        },
        onReadyStateUpdate({ name }) {
            const isSDKReady = name === this.TIM.EVENT.SDK_READY ? true : false;
            console.log("接受状态");
            if (isSDKReady) {
                console.log("准备好嘞");
                this.$store.dispatch("im/changeSDKReady", isSDKReady);
            }
            if (name === this.TIM.EVENT.SDK_NOT_READY) {
                console.log("退出了");
                // this.$store.dispatch('im/imLogin')
            }
        },
        onError({ data }) {
            if (data.message !== "Network Error") {
                this.$store.commit("showMessage", {
                    message: data.message,
                    type: "error"
                });
            }
        },
        onReceiveMessage({ data: messageList }) {
            console.log("接收到信息", messageList);
            this.$store.commit("im/updateCurrSessionMsgs", {
                type: "put",
                message: messageList[0]
            });
        }
    }
};
</script>

<style lang="scss">
:root {
    .custom-loading {
        background-color: transparent;
        .van-toast__loading {
            color: #00bcd1;
        }
    }
}

/* * {
    -webkit-overflow-scrolling: touch;
} */
html,
body {
    margin: 0;
    padding: 0;
    font-family: PingFangSC-Regular, PingFang SC;
}

#app {
    width: 100vw;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
    vertical-align: bottom;
    animation: all 2s;
    word-break: break-all;
}

.base-color {
    color: #00bcd1 !important;
}

/* margin */
.margin-top-df {
    margin-top: 4vw !important;
}

.margin-bottom-df {
    margin-bottom: 4vw !important;
}

/* padding */
.padding-df {
    padding: 4vw;
}

.padding-tb-df {
    padding: 4vw 0;
}

.clear {
    clear: both;
}

.span-line {
    display: inline-block;
    margin: 0 1vw;
    width: 1px;
    height: 2.7vw;
    background-color: #ececec;
}

.tag-hosp {
    position: relative;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    padding: 0 1vw;
    color: #00bcd1;
    background-color: rgba(0, 188, 209, 0.1);
    font-size: 2.4vw;
    line-height: 4vw;
    border-radius: 0.3vw;
    transform: scale(0.9);
}

.form-label {
    color: #12141a !important;
    font-weight: bold !important;
    font-size: 4vw !important;
}

/* im 样式 */
.status-card {
    width: 4.8vw;
    height: 4.8vw;
    background-size: 4.8vw 4.8vw;
    background-repeat: no-repeat;
    display: inline-block;
    margin-right: 1vw;
}

.unSend-status {
    animation: rotate 3s linear infinite;
    background-image: url("./assets/chat-loading.png");
}

.fail-status {
    background-image: url("./assets/chat-error.png");
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}

.border-radius {
    border-radius: 2.1vw;
}

.btn-radius {
    display: inline-block;
    border-radius: 1.6vw;
    overflow: hidden;
}

.text-sm {
    font-size: 3.2vw;
}

.text-md {
    font-size: 3.73vw;
}

.text-df {
    font-size: 4.8vw;
}

.text-xl {
    font-size: 5.53vw;
}

.text-right {
    text-align: right;
}

.text-center {
    text-align: center;
}

.text-left {
    text-align: left;
}

.text-000 {
    color: #000;
}

.text-333 {
    color: #333;
}

.text-666 {
    color: #666;
}

.text-999 {
    color: #999;
}

.text-1A1A1A {
    color: #1a1a1a;
}

.text-primary {
    color: #00bcd1 !important;
}

.text-red {
    color: #ff3355;
}

.red-toast {
    font-size: 2.6vw;
    color: red;
    line-height: 4vw;
    margin-bottom: 1vw;
}

/* H5协议页面 */
.h5-content h2 {
    font-size: 21px;
    font-weight: bold;
    margin: 10px 0;
    text-align: center;
}

.h5-introduction {
    padding: 15px;
}

.h5-content p,
.h5-content div {
    font-size: 14px;
    color: #444;
    line-height: 28px;
}

.h5-content img {
    width: 100%;
}

.h5-content p {
    text-indent: 28px;
}

.h5-content h3 {
    font-size: 21px;
    font-weight: bold;
    /*color: #fe0100;*/
    margin: 15px 0;
}

.h5-content h4 {
    font-size: 13px;
    color: #666666;
    margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue